import styled from "styled-components";

export const OrderModalWrapper = styled.div`
  background-color: ${(p) => p.theme.COLORS.drawerBgColor};
  border-radius: 30px;
  align-items: flex-start;
  flex-direction: row;
  padding: 20px;
`;
